import CoreBase from '../../../../../services/engines/CoreBase';
import iframeController from '../IframeController';
import entryUpdater from '../EntryUpdater';

class UpdateHandler extends CoreBase {
    _name = 'UpdateHandler';

    /**
     * Handles jerny:update — updates daypart, text or name on an existing entry by ems and persists.
     * @param {MessageEvent} e
     * @param {HTMLIFrameElement} iframe
     * @param {object} entry
     */
    handle = (e, iframe, entry) => {
        try {
            if (e.source !== iframe?.contentWindow) return;

            const { ems, daypart, text, name } = e.data?.entry ?? {};
            if (!ems) return;

            const body = iframeController.parseBody(entry);
            if (!body) return;

            const item = body.userInput?.find(i => i.ems === ems);
            if (!item) return;

            // Only update fields that are explicitly provided
            if (daypart !== undefined) item.daypart = daypart;
            if (text    !== undefined) item.text    = text;
            if (name    !== undefined) item.name    = name;

            entryUpdater.update(entry, body);
        } catch (error) {
            this.logError('handle', error.message);
        }
    };
}

const updateHandler = new UpdateHandler();
export default updateHandler;
